import helpers from "^/utils/productHelpers.js"


function isAddToCartDisabled(product, isAddingToCart, isButtonDisabled) {
  const isNotReplenishable = helpers.isProductNotReplenishable(product);
  const isComingSoon = helpers.isProductComingSoon(product);
  const isRetailersOnly = helpers.isProductRetailersOnly(product);
  return (
    isNotReplenishable || isAddingToCart || isButtonDisabled || isComingSoon || isRetailersOnly
  );
}

export default {
  ...helpers,
  isAddToCartDisabled,
}



// WEBPACK FOOTER //
// ./ixcms/themes/gunoldcan/src/vue-src/utils/productHelpers.js